export const BASE_URL = 'https://bitstore.onrender.com'